import { Button, Divider, HStack, Text } from "@chakra-ui/react";
import { useStore } from "../../Store";
import { ActionModal } from "./Modal";
import { useMessageParentOrRedirect } from "../../utils/useMessageParentOrRedirect";

export const CancelContinueButtons = ({
  OnclickContinue,
  btnContinueText,
  btnCancelText,
  btnDisableContinue,
  message = "",
  step = "",
  OnclickCancel = null,
}: any) => {
  const {
    setToken,
    setSessionDetails,
    setLoading,
    sessionDetails,
    showPopup,
    setShowPopup,
    setShowPopupError,
    setPopupErrorMessage,
    setSelectedDataHolder,
    setSelectedConsent,
    setData,
    data,
    isEmbedded,
  } = useStore();
  const { messageParentOrRedirect } = useMessageParentOrRedirect();

  function clearData() {
    // setAccess(false);
    setData(null);
    setLoading(false);
    setPopupErrorMessage("");
    setSelectedConsent(null);
    setSelectedDataHolder(null);
    setSessionDetails(null);
    setShowPopup(false);
    setShowPopupError(false);
    setToken(null);
    sessionStorage.clear();
  }

  return (
    <>
      <ActionModal
        data-testid="modalMessage"
        show={showPopup}
        title="Cancel"
        handleOnClose={() => setShowPopup(false)}
        handleAction={() => {
          messageParentOrRedirect("CANCELLED", {
            state: data?.session.state!,
            isEmbedded: isEmbedded,
            message: `Cancelled at step ${step}`,
            redirectUriBase: data?.session.redirectUri!,
            flow: sessionDetails?.flow!,
            consentId: data?.consent?.id!,
            sessionId: sessionDetails?.sessionId,
          });
          clearData();
        }}
        confirmButtonText="Yes"
        cancelButtonText="No"
        size="lg"
      >
        <>
          {message && <Text>{message}</Text>}
          {Boolean(!message) && (
            <>
              <Text>
                By not sharing your bank data we will not be able to
                automatically collect this information. However, you can still
                provide this information manually for us to track your budget.
              </Text>

              <Divider my={4} />

              <Text>Are you sure you would like to cancel this process?</Text>
            </>
          )}
        </>
      </ActionModal>
      <HStack justifyContent="center" spacing={7} mt={8} mb={2}>
        <Button
          variant="secondary"
          w="190px"
          h="48px"
          aria-label={(btnCancelText ?? "Cancel") + " Button"}
          onClick={
            OnclickCancel === null ? () => setShowPopup(true) : OnclickCancel
          }
        >
          {btnCancelText ?? "Cancel"}
        </Button>
        <Button
          disabled={btnDisableContinue}
          variant="primary"
          w="190px"
          h="48px"
          onClick={OnclickContinue}
        >
          {btnContinueText ?? "Continue"}
        </Button>
      </HStack>
    </>
  );
};
